// extracted by mini-css-extract-plugin
export default {"container":"TextUnder_container__lXaBA","amount":"TextUnder_amount__lndzT","amountText":"TextUnder_amountText__Ni4AX","modal":"TextUnder_modal__-aH6Z"};